"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.IsEventNotification = exports.IsShortMessageNotification = exports.IsFeedPostNotification = exports.EventNotificationType = exports.NotificationType = exports.NotificationMethod = void 0;
var NotificationMethod;
(function (NotificationMethod) {
    NotificationMethod[NotificationMethod["NONE"] = 0] = "NONE";
    NotificationMethod[NotificationMethod["SMS"] = 1] = "SMS";
    NotificationMethod[NotificationMethod["PUSH"] = 2] = "PUSH";
    NotificationMethod[NotificationMethod["EMAIL"] = 3] = "EMAIL";
    NotificationMethod[NotificationMethod["EVENT"] = 4] = "EVENT";
})(NotificationMethod = exports.NotificationMethod || (exports.NotificationMethod = {}));
var NotificationType;
(function (NotificationType) {
    NotificationType[NotificationType["TEXT"] = 0] = "TEXT";
    NotificationType[NotificationType["FEED_POST"] = 1] = "FEED_POST";
    NotificationType[NotificationType["SHORT_MESSAGE"] = 2] = "SHORT_MESSAGE";
    NotificationType[NotificationType["EVENT"] = 3] = "EVENT";
    NotificationType[NotificationType["CHAT"] = 4] = "CHAT";
    NotificationType[NotificationType["ENROLLMENT_APPLICATION"] = 5] = "ENROLLMENT_APPLICATION";
    NotificationType[NotificationType["TUTTI_LOGIN"] = 6] = "TUTTI_LOGIN";
    NotificationType[NotificationType["PERSON_CHANGE_REQUEST"] = 7] = "PERSON_CHANGE_REQUEST";
})(NotificationType = exports.NotificationType || (exports.NotificationType = {}));
var EventNotificationType;
(function (EventNotificationType) {
    EventNotificationType[EventNotificationType["CREATE"] = 0] = "CREATE";
    EventNotificationType[EventNotificationType["CANCEL"] = 1] = "CANCEL";
    EventNotificationType[EventNotificationType["ATTENDANCE_CHANGE"] = 2] = "ATTENDANCE_CHANGE";
    EventNotificationType[EventNotificationType["TIME_CHANGE"] = 3] = "TIME_CHANGE";
    EventNotificationType[EventNotificationType["TIME_ALERT"] = 4] = "TIME_ALERT";
})(EventNotificationType = exports.EventNotificationType || (exports.EventNotificationType = {}));
function IsFeedPostNotification(notification) {
    return notification.type === NotificationType.FEED_POST;
}
exports.IsFeedPostNotification = IsFeedPostNotification;
function IsShortMessageNotification(notification) {
    return notification.type === NotificationType.SHORT_MESSAGE;
}
exports.IsShortMessageNotification = IsShortMessageNotification;
function IsEventNotification(notification) {
    return notification.type === NotificationType.EVENT;
}
exports.IsEventNotification = IsEventNotification;
//# sourceMappingURL=notification.js.map